import { AppModal } from 'shared/UI/UIKit/Modal';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppDeleteIcon } from 'shared/UI/UIKit/icons/Delete';
import { AppText } from 'shared/UI/UIKit/Text';
import type { MaxLessonsPerDay } from 'shared/api';
import { useMaxLessonsPerDayDelete } from '../model';
import styles from './styles.module.scss';

interface MaxLessonsPerDayDeleteProps {
  maxLessonsPerDay: MaxLessonsPerDay;
  refreshTable: () => void;
}

export const MaxLessonsPerDayDelete = ({
  maxLessonsPerDay,
  refreshTable,
}: MaxLessonsPerDayDeleteProps) => {
  const {
    state: { modalVisible },
    methods: { showModal, hideModal, onSubmit },
  } = useMaxLessonsPerDayDelete({ maxLessonsPerDay, refreshTable });

  return (
    <>
      <AppDeleteIcon className={styles.icon} onClick={showModal} />

      <AppModal
        content={<AppText>Подтвердите удаление конфигурации {maxLessonsPerDay.name}</AppText>}
        title="Удалить конфигурацию"
        visible={modalVisible}
        onCancel={hideModal}
        destroyOnClose
        footer={
          <AppFlex direction="row">
            <AppButton type="primary" onClick={onSubmit}>
              Удалить
            </AppButton>
            <AppButton type="outline" onClick={hideModal}>
              Закрыть
            </AppButton>
          </AppFlex>
        }
      />
    </>
  );
};
